<template>
  <div class="container">
    <span class="title is-3">{{empresa.nombrec}}</span>
    <small class="title is-5">{{empresa.nit | textnumber()}}{{empresa.nit | dverif()}}</small>
    <small class="subtitle is-7">{{empresa.nombre}}</small>
    <hr />
    <div style="margin-top: 32px; margin-bottom:32px;">
      <button class="button is-medium is-light" v-on:click="showList()">
        <span class="icon is-small">
          <span class="material-icons">list</span>
        </span>
        <span>Lista</span>
      </button>
      <button class="button is-medium is-light" v-on:click="showCreateForm()">
        <span class="icon is-small">
          <span class="material-icons">add_circle_outline</span>
        </span>
        <span>Crear</span>
      </button>
    </div>
    <div>
      <p class="title">{{title}}</p>
      <div class="table-container" v-if="statebutton=='ver_lista' && editable==false">
        <table class="table is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-for="(centroCosto, index) in listaCCostos" :key="index">
            <tr>
              <th>{{centroCosto.codigo}}</th>
              <td style="display:flex; justify-content:space-between">{{centroCosto.nombre}}</td>
              <td>
                <span class="icon has-text-info hand" @click="selectCCosto(centroCosto)">
                  <i class="material-icons">edit</i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="columns" v-if="statebutton=='crear' && editable==false">
        <div class="column">
          <p class="title is-5">Código</p>
          <div>
            <input v-model="codigo" class="input" type="text" placeholder="Código" />
          </div>
        </div>
        <div class="column">
          <p class="title is-5">Nombre</p>
          <div>
            <input v-model="nombre" class="input" type="text" placeholder="Nombre" />
          </div>
        </div>
      </div>
      <div class="columns" v-if="statebutton=='crear' && editable==false">
        <div class="column">
          <div class="buttons" style="margin-top:16px;">
            <button @click="saveCCosto" class="button is-info is-medium">
              <span class="icon">
                <span class="material-icons">save</span>
              </span>
              <span>Guardar</span>
            </button>
            <button class="button is-medium" v-on:click="showList()">
              <span class="icon">
                <span class="material-icons">cancel</span>
              </span>
              <span>Cancelar</span>
            </button>
          </div>
        </div>
      </div>
      <div v-show="editable==true " class="columns">
        <div class="column">
          <p class="title is-5">Código: {{editCode}}</p>
          <div>
            <input
              v-model="dataToEditCosto.codigo"
              name="input-edit-code"
              id="input-edit-code"
              class="input is-medium"
              type="text"
              placeholder="Nuevo código"
            />
          </div>
        </div>
        <div class="column">
          <p class="title is-5">Nombre: {{editName}}</p>
          <div>
            <input
              v-model="dataToEditCosto.nombre"
              class="input is-medium"
              type="text"
              placeholder="Nuevo nombre"
            />
          </div>
        </div>
      </div>
      <div v-show="editable==true " class="columns">
        <div class="column">
          <div class="buttons" style="margin-top:16px;">
            <button class="button is-medium is-info" v-on:click="saveChange">
              <span class="icon">
                <span class="material-icons">edit</span>
              </span>
              <span>Editar</span>
            </button>
            <button class="button is-medium" v-on:click="cancelEdit()">
              <span class="icon">
                <span class="material-icons">cancel</span>
              </span>
              <span>Cancelar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      codigo: "",
      nombre: "",
      title: "Centro de costos",
      statebutton: "ver_lista",
      listaCCostos: [],
      editable: false,
      editCode: "",
      editName: "",
      dataToEditCosto: {
        nombre: "",
        codigo: "",
        _id: "",
      },
      showEditCosto: false,
      codes: [],
    };
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    saveCCosto() {
      var found;
      this.listaCCostos.forEach((ele) => {
        this.codes.push(ele.codigo);
      });
      if (this.codigo && this.nombre) {
        found = this.codes.includes(this.codigo);
        if (!found) {
          this.title = "Centro de costos";
          this.statebutton = "ver_lista";
          this.createCCosto(this);
        }
      } else {
        this.$store.dispatch("notify", {
          message: "Debe diligenciar todos los campos.",
          type: "is-warning",
          position: "top-center",
        });
      }
    },
    async createCCosto(_this) {
      try {
        const data = {
          nombre: this.nombre,
          codigo: this.codigo,
        };
        let result;
        result = await apiServices.post(`/createccosto`, data);
        this.listaCCostos.push(result.data);
        this.$store.dispatch("notify", {
          message: "Perfecto!. Centro de costo creado.",
        });
        this.nombre = "";
        this.codigo = "";
      } catch (err) {
        console.log(err);
      }
    },
    showCreateForm() {
      this.title = "Crear centro de costo";
      this.statebutton = "crear";
      this.editable = false;
      this.hoverEdit = false;
    },
    showList() {
      this.title = "Centro de costo";
      this.statebutton = "ver_lista";
      this.editable = false;
    },
    selectCCosto(centroCosto) {
      this.showEditCCosto();
      this.dataToEditCosto.codigo = centroCosto.codigo;
      this.dataToEditCosto._id = centroCosto._id;
      this.dataToEditCosto.nombre = centroCosto.nombre;
      this.editable = true;
    },
    showEditCCosto() {
      if (this.showEditCosto) {
        this.showEditCosto = false;

        this.statebutton = "ver_lista";
      } else {
        this.showEditCosto = true;
      }
    },
    saveChange() {
      if (this.dataToEditCosto.nombre && this.dataToEditCosto.codigo) {
        this.editCcosto(this, this.dataToEditCosto);
        this.editable = false;
        this.dataToEditCosto = {
          nombre: "",
          codigo: "",
          _id: "",
        };
      } else {
        this.$store.dispatch("notify", {
          message: "Debe diligenciar todos los campos.",
          type: "is-warning",
          position: "top-center",
        });
      }
    },
    cancelEdit() {
      this.title = "Centro de costo";
      this.editable = false;
      this.statebutton = "ver_lista";
    },
    async editCcosto(_this, costo) {
      console.log(costo);
      try {
        let result;
        result = await apiServices.post(`/editcosto`, costo);
        if (result.data && result.data.message) {
          this.$store.dispatch("notify", {
            message: "El código ya se encuentra en la base de datos.",
            type: "is-danger",
            position: "top-center",
          });
        } else {
          this.dataToEditCosto = {
            nombre: "",
            codigo: "",
            _id: "",
          };
          this.listaCCostos.forEach(function (k) {
            if (k._id === result.data._id) {
              k.nombre = result.data.nombre;
              k.codigo = result.data.codigo;
            }
          });
          this.$store.dispatch("notify", {
            message: "Perfecto!. Centro de costo editado con éxito.",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findCCostos() {
      try {
        const result = await apiServices.get(`/ccostos`);
        // for (this.obj in result.data) {
        // const objectCCostos = {
        //   codigo: result.data[this.obj].codigo,
        //   nombre: result.data[this.obj].nombre,
        //   id: result.data[this.obj]._id,
        // };

        // this.listaCCostos.push(objectCCostos);
        // }
        this.listaCCostos = result.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findCCostos();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/configurations/costcenter/Costcenter.vue